import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { OneSnackBarModule } from '@one/angular-kit/modal';
// import { LearnMoreDialogModule } from '@dia/dialog-reusable-components';
// import { RequestAccessDialogModule } from '@dia/dialog-reusable-components';
// import { FeatureFlagModule } from '@dia/dialog-reusable-components';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { CookieService } from 'ngx-cookie-service';
import { DndDirective } from './direcitves/dnd.directive';
import { FileUploadService } from './file-upload/file-upload.service';
import { FileUploadMultipleComponent } from './file-upload/file-upload-multiple/file-upload-multiple.component';
import { FileUploadSingleComponent } from './file-upload/file-upload-single/file-upload-single.component';

@NgModule({
  declarations: [FileUploadComponent, DndDirective, FileUploadMultipleComponent,FileUploadSingleComponent],
  exports: [FileUploadComponent, FileUploadMultipleComponent,FileUploadSingleComponent],
  imports: [CommonModule, MatCardModule, MatIconModule, MatButtonModule, OneSnackBarModule, /*LearnMoreDialogModule, RequestAccessDialogModule, FeatureFlagModule*/],
  providers: [CookieService, FileUploadService]
})
export class FileUploadFeatureModule {}
